import { getHeaders } from '@utility/helperFunction';
import { utills } from '@utility';

export const GET_VENUE_STORES_REQUESTED = 'venue/GET_VENUE_STORES_REQUESTED';
export const GET_VENUE_STORES_SUCCESS = 'venue/GET_VENUE_STORES_SUCCESS';
export const GET_VENUE_STORES_FAILURE = 'venue/GET_VENUE_STORES_FAILURE';

export const SET_VENUE_MODE = 'venue/SET_VENUE_MODE';

export const GET_VENUE_NOTIFICATIONS_REQUEST = 'venue/GET_VENUE_NOTIFICATIONS_REQUEST';
export const GET_VENUE_NOTIFICATIONS_SUCCESS = 'venue/GET_VENUE_NOTIFICATIONS_SUCCESS';
export const UPDATE_VENUE_NOTIFICATIONS = 'venue/UPDATE_VENUE_NOTIFICATIONS';
export const GET_VENUE_NOTIFICATIONS_FAILURE = 'venue/GET_VENUE_NOTIFICATIONS_FAILURE';

const initialState = {
    loading: false,
    loaded: false,
    error: false,
    isVenueMode: false,
    venueStores: [],
    venueNotificationTableData: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_VENUE_MODE:
            return {
                ...state,
                isVenueMode: action.payload
            }

        case GET_VENUE_STORES_REQUESTED:
            return {
                ...state,
                loading: true,
                loaded: false,
                error: false,
            }

        case GET_VENUE_STORES_SUCCESS:
            // window.sessionStorage.setItem('venuesInfo', JSON.stringify(action.result));
            return {
                ...state,
                loading: false,
                loaded: true,
                error: false,
                venueStores: action.result
            }

        case GET_VENUE_STORES_FAILURE:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: true,
            }
        case GET_VENUE_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                loaded: false,
                error: false,
            };

        case GET_VENUE_NOTIFICATIONS_SUCCESS: {
            const notificationList = (utills.decriptRespose(action.result?.compressedData) || []);
            return {
                ...state,
                loading: false,
                error: false,
                loaded: true,
                venueNotificationTableData: notificationList,
            };
        }

        case UPDATE_VENUE_NOTIFICATIONS: {
            return {
                ...state,
                loading: false,
                error: false,
                loaded: true,
                venueNotificationTableData: [...state.venueNotificationTableData, action.payload],
            };
        }

        case GET_VENUE_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: true,
            };
    }
    return state;

}

export const setVenueMode = (data) => {
    return {
        type: SET_VENUE_MODE,
        payload: data,
    }
}

export const getVenueStores = (deviceId) => {
    const headers = getHeaders();

    return {
        types: [
            GET_VENUE_STORES_REQUESTED,
            GET_VENUE_STORES_SUCCESS,
            GET_VENUE_STORES_FAILURE,
        ],
        promise: client => client.get(`getVenueStores/${deviceId}`, { headers })
    }
}

export const getVenueNotification = (venueId) => {
    const headers = getHeaders();
    return {
        types: [GET_VENUE_NOTIFICATIONS_REQUEST, GET_VENUE_NOTIFICATIONS_SUCCESS, GET_VENUE_NOTIFICATIONS_FAILURE],
        promise: (client) => client.get(`venueNotifications/${venueId}`, { headers }),
    };
};